import Vue from "vue";
import VueRouter from "vue-router";
import { optionShare } from "../plugins/WxConfig";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "@/views/maintenance/maintenance-home"
      ),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/home",
    name: "Home",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "@/views/maintenance/maintenance-home"
      ),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/search-page",
    name: "search-page",
    component: () =>
      import(
        /* webpackChunkName: "searchPage" */ "@/views/maintenance/search-page"
      ),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/maintenance-feedback",
    name: "maintenance-feedback",
    component: () =>
      import(
        /* webpackChunkName: "feedback" */ "@/views/maintenance/maintenance-feedback"
      ),
    meta: {
      title: "反馈",
    },
  },
  {
    path: "/engine-oil-recommend",
    name: "engine-oil-recommend",
    component: () =>
      import(
        /* webpackChunkName: "engine-oil" */ "@/views/maintenance/engine-oil-recommend"
      ),
    meta: {
      title: "机油保养推荐",
    },
  },
  {
    path: "/category-select",
    name: "category-select",
    component: () =>
      import(
        /* webpackChunkName: "engine-oil" */ "@/views/maintenance/category-select"
      ),
    meta: {
      title: "保养类别选择页面",
    },
  },
  {
    path: "/transmission-oil-recommend",
    name: "transmission-oil-recommend",
    component: () =>
      import(
        /* webpackChunkName: "transmission-oil" */ "@/views/maintenance/transmission-oil-recommend"
      ),
    meta: {
      title: "变速箱油保养推荐",
    },
  },
  {
    path: "/gearbox-oil-poster",
    name: "gearbox-oil-poster",
    component: () =>
      import(
        /* webpackChunkName: "gearbox-oil-poster" */ "@/views/maintenance/gearbox-oil-poster"
      ),
    meta: {
      title: "变速箱油海报生成",
    },
  },
  {
    path: "/tire-recommend",
    name: "tire-recommend",
    component: () =>
      import(
        /* webpackChunkName: "tire" */ "@/views/maintenance/tire-recommend"
      ),
    meta: {
      title: "轮胎保养推荐",
    },
  },
  {
    path: "/oil-filter-recommend",
    name: "oil-filter-recommend",
    component: () =>
      import(
        /* webpackChunkName: "oil_filter" */ "@/views/maintenance/oil-filter-recommend"
      ),
    meta: {
      title: "机油滤清器保养信息",
    },
  },
  {
    path: "/maintenance-cycle",
    name: "maintenance-cycle",
    component: () =>
      import(
        /* webpackChunkName: "cycle" */ "@/views/maintenance/maintenance-cycle"
      ),
    meta: {
      title: "保养周期",
    },
  },
  {
    path: "/maintenance-config",
    name: "maintenance-config",
    component: () =>
      import(
        /* webpackChunkName: "cycle" */ "@/views/maintenance/maintenance-config"
      ),
    meta: {
      title: "车辆配置",
    },
  },
  {
    path: "/maintenance-good",
    name: "maintenance-good",
    component: () =>
      import(
        /* webpackChunkName: "cycle" */ "@/views/maintenance/maintenance-good"
      ),
    meta: {
      title: "商品详情",
    },
  },
  // 没有有效路由指向
  {
    path: "/maintenance-other-recommend",
    name: "maintenance-other-recommend",
    component: () =>
      import(
        /* webpackChunkName: "cycle" */ "@/views/maintenance/maintenance-other-recommend"
      ),
    meta: {
      title: "其他保养项目推荐",
    },
  },
  {
    path: "/detail",
    name: "oil-detail",
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/maintenance/detail"),
    meta: {
      title: "保养助手详情",
    },
  },
  {
    path: "/maintenance-detail",
    name: "maintenance-detail",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "@/views/maintenance/maintenance-detail"
      ),
    meta: {
      title: "保养助手详情",
    },
  },
  {
    path: "/view-video",
    name: "view-video",
    component: () =>
      import(
        /* webpackChunkName: "video" */ "@/views/maintenance/components/ViewVideo"
      ),
    meta: {
      title: "视频播放(自定义遮罩)",
    },
  },
  {
    path: "/insurance-introduction",
    name: "insurance-introduction",
    component: () =>
      import(
        /* webpackChunkName: "insurance" */ "@/views/landing/insurance-introduction"
      ),
    meta: {
      title: "安心保详情页",
    },
  },
  {
    path: "/insurance-poster",
    name: "insurance-poster",
    component: () =>
      import(
        /* webpackChunkName: "insurance" */ "@/views/landing/insurance-poster"
      ),
    meta: {
      title: "安心保海报页面",
    },
  },
  {
    path: "/years-sale-names",
    name: "years-sale-names",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "@/views/maintenance/years-sale-names"
      ),
    meta: {
      title: "选择车型",
    },
  },
  {
    path: "/engine-displacement",
    name: "engine-displacement",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "@/views/maintenance/engine-displacement"
      ),
    meta: {
      title: "选择车型",
    },
  },
  {
    path: "/img-detail",
    name: "img-detail",
    component: () =>
      import(
        /* webpackChunkName: "img-detail" */ "@/views/maintenance/img-detail"
      ),
    meta: {
      title: "图文详情",
    },
  },
  {
    path: "/love-value-mall-poster",
    name: "love-value-mall-poster",
    component: () =>
      import(
        /* webpackChunkName: "love-value-mall-poster" */ "@/views/chaofandashi/love-value-mall-poster"
      ),
    meta: {
      title: "热爱值",
    },
  },
  {
    path: "*",
    name: "404-page",
    component: () =>
      import(/* webpackChunkName: "cycle" */ "@/views/default/404"),
    meta: {
      title: "商品详情",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});

router.afterEach((to) => {
  if (!JSON.parse(window.sessionStorage.getItem("wxsdkReady"))) {
    optionShare(to.query.scheme_id || to.query.id);
  }
});

export default router;
